import React from "react";
import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { WaterShimmer } from "./WaterShimmer";

const HERO_VIDEO = "/amme/drone.mp4";
const HERO_POSTER = "/amme/drone-poster.jpg";

export const Hero = ({ t }) => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen w-full flex flex-col justify-end overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <motion.div
          initial={{ scale: 1.08 }}
          animate={{ scale: 1 }}
          transition={{ duration: 6, ease: [0.22, 1, 0.36, 1] }}
          className="absolute inset-0 overflow-hidden"
        >
          <video
            data-testid="hero-video"
            className="absolute inset-0 w-full h-full object-cover"
            poster={HERO_POSTER}
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
          >
            <source src="/amme/drone.webm" type="video/webm" />
            <source src={HERO_VIDEO} type="video/mp4" />
          </video>
        </motion.div>
        <WaterShimmer opacity={0.18} />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/70" />
        <div className="absolute inset-0 grain-overlay opacity-25 pointer-events-none" />
      </div>

      <div className="relative z-10 max-w-[1600px] mx-auto w-full px-6 md:px-12 pb-16 md:pb-24">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.6 }}
          className="text-white/80 text-[11px] uppercase tracking-[0.4em] mb-6 md:mb-8"
        >
          {t.hero.location}
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.4, delay: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif text-white text-[15vw] md:text-[9vw] lg:text-[7.5vw] leading-[0.9] font-light tracking-tight"
          data-testid="hero-headline"
        >
          {t.hero.tagline}
          <br />
          <span className="italic font-light text-white/95">{t.hero.taglineItalic}</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 1.4 }}
          className="mt-8 md:mt-10 max-w-xl text-white/85 text-base md:text-lg font-light leading-relaxed"
        >
          {t.hero.subtitle}
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.8 }}
          className="mt-12 md:mt-16 flex items-center gap-3 text-white/70 text-[10px] uppercase tracking-[0.4em]"
        >
          <span>{t.hero.scroll}</span>
          <ArrowDown size={14} strokeWidth={1} className="animate-bounce-slow" />
        </motion.div>
      </div>
    </section>
  );
};
